import { render } from "./BarraLateral.vue?vue&type=template&id=42805758&scoped=true"
import script from "./BarraLateral.vue?vue&type=script&lang=js"
export * from "./BarraLateral.vue?vue&type=script&lang=js"

import "./BarraLateral.vue?vue&type=style&index=0&id=42805758&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42805758"]])

export default __exports__